import { Loader2 } from "lucide-react";
import type { CreanceRow } from "@/lib/creance.api";
import type { CreanceViewMode } from "../creance.constants";
import { CreanceGrid } from "./CreanceGrid";
import { CreancesTable } from "./CreancesTable";

interface CreancesContentProps {
  rows: CreanceRow[];
  viewMode: CreanceViewMode;
  isLoading: boolean;
  onSelect: (row: CreanceRow) => void;
}

export function CreancesContent({ rows, viewMode, isLoading, onSelect }: CreancesContentProps) {
  if (viewMode === "table") {
    return <CreancesTable rows={rows} loading={isLoading} onSelect={onSelect} />;
  }

  if (isLoading) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  return <CreanceGrid rows={rows} onSelect={onSelect} />;
}
